export const mapConfigOrLiteral = [
  {
    type: 'trenchRun',
    id: 'sandbox',
    assetName: 'sandbox',
    name: 'loc:::sandbox_name',
    teamCount: 1,
    teamSize: 1,
    debugOnly: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::sandbox_name',
      dataKey: 'outpostRunLobby'
    }
  },
  {
    type: 'trenchRun',
    id: 'level-tutorial',
    assetName: 'level-tutorial',
    name: 'loc:::map_config_tutorial',
    teamCount: 1,
    teamSize: 1,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_tutorial',
      dataKey: 'outpostRunLobby'
    }
  },
  {
    type: 'trenchRun',
    id: 'level-1',
    assetName: 'level-1',
    name: 'loc:::map_config_outpost_run_1_name',
    unlockedByMapId: 'level-tutorial',
    teamCount: 1,
    teamSize: 1,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_or_level_1_name',
      dataKey: 'outpostRunLobby',
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  },
  {
    type: 'trenchRun',
    id: 'level-2',
    assetName: 'level-2',
    name: 'loc:::map_config_outpost_run_2_name',
    unlockedByMapId: 'level-1',
    teamCount: 1,
    teamSize: 1,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_or_level_2_name',
      dataKey: 'outpostRunLobby',
      unlockTooltip: 'loc:::completeLevel1ToUnlock'
    }
  },
  {
    type: 'trenchRun',
    id: 'level-3',
    assetName: 'level-3',
    name: 'loc:::map_config_outpost_run_3_name',
    unlockedByMapId: 'level-2',
    teamCount: 1,
    teamSize: 1,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_or_level_3_name',
      dataKey: 'outpostRunLobby',
      unlockTooltip: 'loc:::completeLevel2ToUnlock'
    }
  }
] as const;
